export const parseUrl = (url: string = ""): URL => {
  return new URL(url, document.baseURI);
};

export const isCrossOrigin = (url: string = ""): boolean => {
  return parseUrl(url).origin !== window.location.origin;
};

export const userCademi = (search: string = ""): string => {
  const queryString = new URLSearchParams(search);
  const id = queryString.get("cuser_id");
  const name = queryString.get("cuser_name");
  const email = queryString.get("cuser_email");
  if (!id && !name && !email) return '';
  return `?id=${id}&name=${name}&email=${email}`;
};

export const buildQueryString = (search: string = ""): string => {
  if (!search) return '';
  const queryString = new URLSearchParams(search);
  return `${queryString.toString()}&`;
}
